import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'kpi-definition-button',
  templateUrl: './kpi-definition-button.component.html',
  styleUrls: ['./kpi-definition-button.component.less'],
  standalone: false
})
export class KpiDefinitionButtonComponent {
  @Input() item: any;
  @Input() showCondition: boolean = true;
  @Input() tooltip: string = '';
  @Input() buttonText: string = 'KPI definition';
  @Input() disabled: boolean = false;

  @Output() kpiDefinitionClick = new EventEmitter<any>();

  onKpiDefinitionClick(): void {
    if (!this.disabled && this.item) {
      this.kpiDefinitionClick.emit(this.item);
    }
  }
} 